module.exports = __webpack_public_path__ + "/login_ui/img/ug-6d5ab5bcf49e8c4f8508858758402a8a.svg";